module.exports = __webpack_public_path__ + "static/img/list-comfortGelBlue.6755c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/list-comfortGelBlue.png
// module id = c49r
// module chunks = 1